import ctl from '@netlify/classnames-template-literals';

export const pageRangeStyle = ctl(`
  mt-2 
  text-sm 
  text-center 
  text-chinese-silver
  select-none
`);
